import { httpsCallable } from "firebase/functions";
import { Capacitor } from "@capacitor/core";
import { auth, ensureAppCheckReady, functions } from "../firebase";
import { markPerformance } from "./performanceTrace";

const protectedCall = async (name, payload) => {
  const appCheck = await ensureAppCheckReady();
  if (!appCheck?.enabled) {
    const error = new Error("Não foi possível validar a segurança do aplicativo. Verifique sua conexão e tente novamente.");
    error.code = "app-check/unavailable";
    throw error;
  }
  return (await httpsCallable(functions, name)(payload)).data;
};
// These onboarding/legal calls are already authenticated server-side and only
// read/write the caller's own UID. Do not strand an authenticated iOS user when
// Apple attestation is temporarily unavailable; the backend still rejects any
// request without a valid Firebase Auth session.
const authenticatedLegalCall = async (name, payload) => {
  const startedAt = performance.now();
  const operation = name === "recordLegalAcceptance" ? "LEGAL_WRITE" : name === "getLegalReadiness" ? "LEGAL_STATUS" : "LEGAL_SECONDARY";
  markPerformance(`${operation}_REQUEST_SENT`, {
    callable: name,
    authenticated: Boolean(auth.currentUser),
    endpoint: `https://us-central1-zuno-novo.cloudfunctions.net/${name}`,
  });
  try {
    const response = await httpsCallable(functions, name)(payload);
    markPerformance(`${operation}_RESPONSE`, {
      callable: name,
      durationMs: Math.round(performance.now() - startedAt),
      status: "success",
    });
    return response.data;
  } catch (error) {
    markPerformance(`${operation}_RESPONSE`, {
      callable: name,
      durationMs: Math.round(performance.now() - startedAt),
      status: "error",
      code: error?.code || "unknown",
      message: error?.message || "unknown",
    });
    throw error;
  }
};
const platform = () => Capacitor.getPlatform() || "web";

export const getLegalReadiness = async (role = "passenger") => authenticatedLegalCall("getLegalReadiness", { role });

export const recordLegalAcceptance = async (types, origin = "passenger_onboarding") => (
  authenticatedLegalCall("recordLegalAcceptance", { types, origin, platform: platform(), appVersion: "1.0.0" })
);

export const updateMarketingPreference = async (enabled, origin = "privacy_center") => (
  authenticatedLegalCall("updateMarketingPreference", { enabled, origin, platform: platform() })
);

export const checkServiceAvailability = async (origin, category) => (
  protectedCall("checkServiceAvailability", { origin, category })
);

export const joinCityInterest = async (payload) => protectedCall("joinCityInterest", payload);

export const getComplianceOverview = async () => protectedCall("getComplianceOverview", {});
